import produce from 'immer';
import { AnyAction } from 'redux';
import { FETCH_CATERORIES } from '../ActionTypes';
import { ICategories } from 'interfaces/Categories';

type InitialStateType = {
  data: ICategories[];
};

export const INIT_STATE: InitialStateType = {
  data: []
};

export const CategoriesReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_CATERORIES:
        draft.data = action.payload.data;
    }
  });
